import { equals } from 'ramda';
import { useEffect } from 'react';

export interface Props<T> {
  defaultValue: T;
  state: T;
  setState: (value: T) => void;
}

export function useDefaultValueWatcher<T>({ defaultValue, state, setState }: Props<T>) {
  useEffect(() => {
    if (!equals(defaultValue, state)) {
      setState(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);
}
